import React from "react";
import { useState } from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import { useEffect } from "react";
import ScholarshipPic from "../resources/images/WhatsApp Image 2025-05-23 at 12.58.50_cc1d3d9d.jpg";
import { FaPlus, FaMinus } from "react-icons/fa";
function Scholarships() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqsData = [
    {
      question: "What programs are offered at the school?",
      answer:
        "We offer Basic Education from Kindergarten to Junior High School with a strong Christian foundation.",
    },
    {
      question: "How can I apply for admission?",
      answer:
        "You can fill out an admission form online or visit the school’s office to apply in person.",
    },
    {
      question: "Do you provide transportation services?",
      answer:
        "Yes, we offer transportation services to various areas within the region.",
    },
    {
      question: "Does the school offer scholarships?",
      answer:
        "Yes. Our scholarship program supports talented students who show strong academic performance, leadership, and commitment to growth. Scholarships are designed to remove financial barriers to accessing quality education.",
    },
    {
      question: "Are there discounts for parents with multiple wards?",
      answer:
        "Yes. Families enrolling two wards receive a 5% tuition discount, while those enrolling three or more receive a 10% discount. Wards must be enrolled full-time for the academic year.",
    },
    {
      question: "Do staff members receive any tuition discounts?",
      answer:
        "Yes. Full-time staff members at Star of the East School Complex receive a 15% tuition discount for their children enrolled in the school.",
    },
    {
      question: "Are discounts applied to all school expenses?",
      answer:
        "No. Discounts apply to tuition fees only. They do not cover books, uniforms, or extracurricular activities.",
    },
    {
      question: "How do I apply for discounts or scholarships?",
      answer:
        "You must apply at the time of enrollment and provide all required documentation to verify eligibility. Discounts and scholarships are reviewed annually.",
    },
    {
      question: "Can support or discounts be terminated?",
      answer:
        "Yes. Support may be terminated for reasons including poor academic performance, misconduct, non-payment of fees, withdrawal of wards, staff resignation, or misrepresentation of information.",
    },
  ];

  const FAQItem = ({ faq, isOpen, onToggle }) => (
    <div className="faq-container">
      <button className="faq-item" onClick={onToggle}>
        <span className="faq-question">{faq.question}</span>
        <span>{isOpen ? <FaMinus size={20} /> : <FaPlus size={20} />}</span>
      </button>

      <p className={isOpen ? "faq-answer-open" : "faq-answer-close"}>
        {faq.answer}
      </p>
    </div>
  );

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="main">
      {/* <QuickContact/> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">Scholarships & Support</h2>
        </div>
        <br />
        <div className="content-page-img">
          <img src={ScholarshipPic} alt="" />
        </div>
        <div className="content-body admission-process">
          <p>
            At Star of the East School Complex, we believe that financial
            barriers should not limit a student’s potential for academic
            success. Our scholarship program is designed to support talented and
            deserving students who demonstrate exceptional academic performance,
            leadership skills, and a commitment to personal growth. By providing
            financial assistance, we aim to make quality education accessible to
            all students, regardless of their financial background. We encourage
            eligible students and their families to explore the various
            scholarship opportunities available and apply to be part of a
            community that values excellence, diversity, and opportunity.
          </p>

          <br />
          <br />
          <br />
          <h2>Parent and Staff Support</h2>
          <br />
          <p>
            At Star of the East School Complex, we deeply value the partnership
            between our school, parents, and staff. To show our appreciation, we
            offer exclusive discounts to parents and guardians who enroll
            multiple children in our school.
          </p>
          <br />
          <strong>Please Note: </strong>
          <ol>
            <li>
              <strong>Number of Wards Enrolled:</strong>
              Parents must enroll at least two children (wards) at Star of the
              East School Complex to qualify for the multi-ward discount.
            </li>
            <li>
              <strong>Discount Structure: </strong>A 5% discount is applied for
              families enrolling two wards, and a 10% discount is provided for
              families with three or more wards.
            </li>
            <li>
              <strong>Full-Time Enrollment: </strong>
              The discount applies only to wards who are enrolled full-time for
              the academic year at Star of the East School Complex.
            </li>
            <li>
              <strong>Staff Eligibility: </strong>
              Staff members must be employed full-time at Star of the East
              School Complex to receive the 15% tuition discount for their
              children.
            </li>
            <li>
              <strong>Discount Validity: </strong>
              Discounts are valid for tuition fees only and do not apply to
              additional costs such as books, uniforms, or extracurricular
              activities.
            </li>
            <li>
              <strong>Application Process: </strong>
              Parents or staff must apply for the discount at the time of
              enrollment, providing all required documentation to verify
              eligibility.
            </li>
            <li>
              <strong>Renewal of Discounts: </strong>
              Discounts are reviewed annually and may be renewed based on
              continued eligibility and satisfactory performance of the
              students.
            </li>
          </ol>
          <br />
          <br />
          <br />

          <h2> Termination of Support</h2>
          <br />
          <p>
            Administration may revise the support policies and or terminate the
            support based on the following conditions
          </p>
          <br />
          <ol>
            <li>
              <strong>Failure to Meet Academic Standards: </strong>
              If the wards do not maintain satisfactory academic performance or
              fail to meet the minimum grade requirements, the support may be
              discontinued.
            </li>{" "}
            <br />
            <li>
              <strong>Withdrawal of Wards: </strong>
              If one or more wards are withdrawn from Star of the East School
              Complex, the multi-ward discount will no longer apply.
            </li>{" "}
            <br />
            <li>
              <strong>Misconduct or Behavioral Issues: </strong>
              Persistent misconduct or disciplinary issues involving any of the
              wards may lead to termination of the support.
            </li>{" "}
            <br />
            <li>
              <strong>Staff Resignation or Termination: </strong>
              In the event that a staff member resigns or is terminated from
              employment at the school, the staff discount will cease
              immediately.
            </li>{" "}
            <br />
            <li>
              <strong>Non-payment of Fees: </strong>
              Failure to pay school fees on time, despite the discount, could
              result in the termination of the support.
            </li>{" "}
            <br />
            <li>
              <strong>Misrepresentation or Fraud: </strong>
              Any attempt to falsify documents or misrepresent information to
              obtain support will result in immediate termination.
            </li>{" "}
            <br />
            <li>
              <strong>Change in Enrollment Status: </strong>
              If the wards’ enrollment status changes from full-time to
              part-time, the discount will no longer be applicable.
            </li>{" "}
            <br />
            <li>
              <strong>Lapse in Communication: </strong>
              Failure to communicate with the school administration regarding
              changes in the family’s situation that affect eligibility for the
              discount may lead to its termination.
            </li>{" "}
            <br />
          </ol>

          <h2>FAQs</h2>
          <br />
          <div className="faqs">
            {/* <h2 className="faqs-header">Frequently Asked Questions</h2> */}
            {faqsData.map((faq, index) => (
              <FAQItem
                key={index}
                faq={faq}
                isOpen={openIndex === index}
                onToggle={() => handleToggle(index)}
              />
            ))}
          </div>
        </div>

        <br />
        <br />
        <br />
        {/* <p className='construction-note'>Still Under Construction</p> */}
      </div>
      <Footer />
    </div>
  );
}

export default Scholarships;
